import { Box } from '@mui/material';
import Footer from '../../shared/footer/Footer';
import AgentInnovators from './agentInnovators/AgentInnovators';
import Header from '../../shared/header/Header';
import WhyAgent from './whyAgent/WhyAgent';
import PublisherBenefits from './publisherBenefits/PublisherBenefits';

function LandingPage() {
  return (
    <Box>
      <Header />
      <AgentInnovators />
      <WhyAgent />
      <PublisherBenefits />
      <Footer />
    </Box>
  );
}

export default LandingPage;
